"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CropControls = void 0;
var _cropUtils = require("../utils/cropUtils");
var _jsxRuntime = require("react/jsx-runtime");
const CropControls = ({
  crop,
  onChange
}) => {
  var orientation = crop.orientation === 'landscape' ? 'landscape' : 'portrait';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "control-group",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      children: "Crop"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "above-top mb-2",
      children: "Choose a print size, then drag the crop box on the image."
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      className: "btn bg-beige w-100 mb-3",
      type: "button",
      onClick: () => onChange({
        aspect: '5x5',
        orientation: 'portrait',
        size: 100,
        x: 50,
        y: 50
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "bi bi-arrow-counterclockwise"
      }), " Reset crop"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "crop-aspect-grid mb-3",
      role: "group",
      "aria-label": "Crop orientation",
      children: ['portrait', 'landscape'].map(option => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: orientation === option ? 'btn bg-green' : 'btn bg-beige',
        type: "button",
        "aria-pressed": orientation === option,
        onClick: () => onChange('orientation', option),
        children: option[0].toUpperCase() + option.slice(1)
      }, option))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "crop-aspect-grid",
      children: _cropUtils.cropAspectRatios.map(ratio => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: crop.aspect === ratio.id ? 'btn bg-green' : 'btn bg-beige',
        type: "button",
        onClick: () => onChange('aspect', ratio.id),
        children: ratio.label
      }, ratio.id))
    })]
  });
};
exports.CropControls = CropControls;